import orderServices from "../API/OrderService";
import { AppDispatch } from "../App/store";
import { CartItems } from "../Interface/Order.interface";
import { fetchOrderSuccess, fetchOrderTrackingData } from "../Slice/Order.Slice";



export const  CartItemsData = (payload:CartItems[]) => async(dispatch:AppDispatch) =>{

    try{
        
        const data = await orderServices.postOrderService(payload)
        dispatch(fetchOrderSuccess(data))

    }

    catch (error) {
      console.error('Login failed:', error);
    }
}


export const getOrderTracking =   (memberId:number) => async (dispatch:AppDispatch) => {
  
  try{
    const data = await orderServices.getTrackingOrders(memberId)
    dispatch(fetchOrderTrackingData(data))
  }
  catch(error){
    console.error('Error in the Get Order Tracking')
  }
}

